import React from 'react';
import { Link } from 'react-router';

const SearchResultsHeader = () => (
  <div className="top-recherche">
    <Link to="/" className="back">
      <i className="ic ic-arrow-left"/>
      <span>Retour</span>
    </Link>
    <div className="result">
      <i className="ic ic-search"/>
      <span>Résultats de recherche</span>
    </div>
  </div>
);

export default SearchResultsHeader;



// WEBPACK FOOTER //
// ./book/src/search/SearchResultsHeader.jsx